module.exports = __webpack_public_path__ + "static/media/bun.601fe960.png";